import { render, staticRenderFns } from "./UnionItem.vue?vue&type=template&id=98d46010&scoped=true&"
import script from "./UnionItem.vue?vue&type=script&lang=js&"
export * from "./UnionItem.vue?vue&type=script&lang=js&"
import style0 from "./UnionItem.vue?vue&type=style&index=0&id=98d46010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d46010",
  null
  
)

export default component.exports